import { type FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type ProductLinkTarget = "product-page" | "checkout"

type Props = {
	value: ProductLinkTarget
	onChange(value: ProductLinkTarget): void
}

const options: { value: ProductLinkTarget; label: string }[] = [
	{ value: "product-page", label: "Academy page" },
	{ value: "checkout", label: "Checkout" },
]

const ProductLinkTargetField: FC<Props> = ({ value, onChange }) => (
	<div className="mb-8 rounded-2xl border border-indigo-100 bg-indigo-50/60 p-5">
		<h3 className="text-sm font-semibold text-gray-900">Purchase link destination</h3>
		<p className="mt-1 text-sm text-gray-600">Choose what opens when a visitor selects a product.</p>
		<div className="mt-4 inline-flex overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
			{options.map((option, index) => (
				<button
					key={option.value}
					type="button"
					aria-pressed={value === option.value}
					onClick={() => onChange(option.value)}
					className={cn(
						"cursor-pointer px-4 py-2 text-sm font-semibold transition",
						index > 0 && "border-l border-gray-200",
						value === option.value ? "bg-gray-900 text-white" : "text-gray-700 hover:bg-gray-50",
					)}
				>
					{option.label}
				</button>
			))}
		</div>
	</div>
)

export default ProductLinkTargetField
